import React, { useState } from 'react';

interface FileItem {
  name: string;
  type: 'file' | 'folder';
  path?: string;
  children?: FileItem[];
}

interface FileTreeProps {
  files: FileItem[];
  onFileSelect?: (filePath: string) => void;
}

interface FileTreeItemProps {
  item: FileItem;
  depth: number;
  onFileSelect?: (filePath: string) => void;
}

const FileTreeItem: React.FC<FileTreeItemProps> = ({ item, depth, onFileSelect }) => {
  const [isExpanded, setIsExpanded] = useState(depth === 0);

  const handleClick = () => {
    if (item.type === 'folder') {
      setIsExpanded(!isExpanded);
    } else if (item.path) {
      onFileSelect?.(item.path);
    }
  };

  return (
    <div>
      <div
        onClick={handleClick}
        style={{
          paddingLeft: `${depth * 16}px`,
          padding: '4px 8px',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          fontSize: '14px',
          color: '#e0e0e0',
          userSelect: 'none',
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.backgroundColor = '#333';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = 'transparent';
        }}
      >
        {item.type === 'folder' && (
          <span style={{ marginRight: '4px', fontSize: '12px' }}>
            {isExpanded ? '▼' : '▶'}
          </span>
        )}
        <span style={{ marginRight: '4px' }}>
          {item.type === 'folder' ? '📁' : '📄'}
        </span>
        <span>{item.name}</span>
      </div>
      {item.type === 'folder' && isExpanded && item.children && (
        <div>
          {item.children.map((child, index) => (
            <FileTreeItem
              key={index}
              item={child}
              depth={depth + 1}
              onFileSelect={onFileSelect}
            />
          ))}
        </div>
      )}
    </div>
  );
};

const FileTree: React.FC<FileTreeProps> = ({ files, onFileSelect }) => {
  return (
    <div style={{ fontSize: '14px', fontFamily: 'monospace' }}>
      {files.map((item, index) => (
        <FileTreeItem
          key={index}
          item={item}
          depth={0}
          onFileSelect={onFileSelect}
        />
      ))}
    </div>
  );
};

export default FileTree;